<template>
    <div class="mainform">
        <div id="opponent_selection">
            <div class="row">
                <div class="col-3" style="display: flex; align-items: center">
                    <h4>Spiel gegen:</h4>
                </div>
                <div class="col-6">
                    <div :class="['options_button', this.globalOptions[0].selected == 'Computer' ? 'active' : '']" @click="optionSelectGlobal('Computer oder Gast', 'Computer')">
                        <i class="fas fa-robot"></i>
                        Computer
                    </div>
                    <div :class="['options_button', this.globalOptions[0].selected == 'Gast' ? 'active' : '']" @click="optionSelectGlobal('Computer oder Gast', 'Gast')">
                        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
    <path fill="currentColor" d="M16 9C22 9 22 13 22 13V15H16V13C16 13 16 11.31 14.85 9.8C14.68 9.57 14.47 9.35 14.25 9.14C14.77 9.06 15.34 9 16 9M2 13C2 13 2 9 8 9S14 13 14 13V15H2V13M9 17V19H15V17L18 20L15 23V21H9V23L6 20L9 17M8 1C6.34 1 5 2.34 5 4S6.34 7 8 7 11 5.66 11 4 9.66 1 8 1M16 1C14.34 1 13 2.34 13 4S14.34 7 16 7 19 5.66 19 4 17.66 1 16 1Z" />
</svg>
                        Gast
                    </div>
                </div>
                <div class="col-12">
                    <hr>
                </div>
            </div>
        </div>
        <div id="matchtype_selection">
            <div class="row">
                <div class="col-3" style="display: flex; align-items: center">
                    <h4>Spielart:</h4>
                </div>
                <div class="col-3" v-for="mtype in matchtypes" v-bind:key="mtype.id">
                    <div :class="['matchtype_button', mtype.id == selectedMatchType.id ? 'active' : '']" @click="matchtypeSelect(mtype.id)">
                        <div class="matchtypename">{{mtype.name}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div id="matchtype_options" v-if="selectedMatchType != null">
            <h3>Spieloptionen</h3>
            <div class="optionSelector" v-for="option in selectedMatchType.options" v-bind:key="option.name">
                <h4>{{option.name}}</h4>
                <div :class="['options_button', option.selected == o ? 'active' : '']" @click="optionSelect(option.name, o)" v-for="o in option.options" v-bind:key="o">
                    {{o}}
                </div>
            </div>
        </div>
        <div id="global_options">
            <h3>Allgemeine Optionen</h3>
            <div v-if="selectedMatchType.id != null">
                <div class="row">
                    <div :class="['', option.class ? option.class : 'col-12']" v-for="option in globalOptions" v-bind:key="option.name">
                        <div class="optionSelector" v-if="filterOption(option)">
                            <h4>{{option.name}}</h4>
                            <div class="div" v-if="option.range">
                                <a href="#" class="options_button range_button" @click.prevent="optionsRangeSelect(option.name, -1)">-</a>
                                <div class="options_button range_button_number">{{option.selected}}</div>
                                <a href="#" class="options_button range_button" @click.prevent="optionsRangeSelect(option.name, 1)">+</a>
                            </div>
                            <div v-else :class="['options_button', option.selected == o ? 'active' : '']" @click="optionSelectGlobal(option.name, o)" v-for="o in option.options" v-bind:key="o">
                                {{o}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="submit mt-3" v-if="selectedMatchType.id != null">
            <a href="#" class="btn btn-primary btn-lg btn-block" @click="submit()">
                <i class="fas fa-plus-square"></i>
                Spiel starten
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                matchtypes: [
                    {id: 4, name: 'X01', options: [
                        {name: 'Start', options: ['101', '301', '501', '701', '901'], selected: '501'},
                        {name: 'In', options: ['Single In', 'Double In', 'Master In'], selected: 'Single In'},
                        {name: 'Out', options: ['Single Out', 'Double Out', 'Master Out'], selected: 'Double Out'},
                    ]},
                    // {id: 5, name: 'Playground', options: []}
                ],
                globalOptions: [
                    {id: 'opponent', name: 'Computer oder Gast', options:['Computer', 'Gast'], selected: 'Computer', hidden: true},
                    {id: 'cpu_level', name: 'Computer Level (Schwierigkeitsgrad)', range:[1,9], selected: 5, class:"col-6", showif:'opponent:Computer'},
                    {id: 'cpu_time', name: 'Umschaltzeit Computer (Sekunden)', range: [1,10], selected: 3, class:"col-6", showif:'opponent:Computer'},
                    {id: 'legs', name: 'Anzahl Legs (First to)', range: [1,27], selected: 1, class:"col-6"},
                    {id: 'sets', name: 'Anzahl Sets (First to)', range: [1,5], selected: 1, class:"col-6"},
                    {id: 'starting_firstleg', name: 'Start Erstes Leg', options: ['Spieler 1', 'Spieler 2', 'Zufall', 'Ausbullen'], selected: "Spieler 1"},
                    {id: 'starting_otherlegs', name: 'Weitere Legs', options: ['Abwechselnd', 'Verlierer beginnt', 'Zufall'], selected: "Abwechselnd"},
                ],
                selectedMatchType: {}
            }
        },
        mounted() {
            this.selectedMatchType = this.matchtypes[0];
        },
        methods: {
            matchtypeSelect: function(id) {
                this.matchtypes.forEach(t => {
                    if (t.id == id) {
                        this.selectedMatchType = t;
                    }
                });
            },
            optionSelect(name, option) {
                this.selectedMatchType.options.forEach(element => {
                    if (element.name == name) {
                        element.selected = option;
                    }
                });
            },
            optionSelectGlobal(name, option) {
                this.globalOptions.forEach(element => {
                    if (element.name == name) {
                        element.selected = option;
                    }
                });
            },
            optionsRangeSelect(name, modifier) {
                this.globalOptions.forEach(element => {
                    if (element.name == name) {
                        element.selected += modifier
                        if (element.selected < element.range[0]) element.selected = element.range[0];
                        if (element.selected > element.range[1]) element.selected = element.range[1];
                    }
                });
            },
            parseOptions() {
                var returnArray = [];
                this.selectedMatchType.options.forEach(element => {
                    returnArray.push({"name": element.name, "value": element.selected});
                });
                return returnArray;
            },
            selectedGlobalOption(id) {
                var chosen = null;
                this.globalOptions.forEach(element => {
                    if (element.id == id) {
                        if (element.selected == "Ja") {
                            chosen = true
                        }
                        else if (element.selected == "Nein") {
                            chosen = false
                        } else {
                            chosen = element.selected;
                        }
                    }
                });
                return chosen;
            },
            parseStartingOptions() {
                var data = [];
                data.push({name: 'starting_firstleg',value: this.selectedGlobalOption('starting_firstleg')});
                data.push({name: 'starting_otherlegs',value: this.selectedGlobalOption('starting_otherlegs')});
                data.push({name: 'cpu_level',value: this.selectedGlobalOption('cpu_level')});
                data.push({name: 'cpu_time',value: this.selectedGlobalOption('cpu_time')});
                data.push({name: 'opponent',value: this.selectedGlobalOption('opponent')});

                //add a random number to determine the starter if random start is selected
                if (this.selectedGlobalOption('starting_firstleg') == "Zufall") {
                    data.push({name: 'starting_number', value: (Math.random()+1)});
                }
                return data;
            },
            submit() {
                var data = {
                    matchtype_id: this.selectedMatchType.id,
                    legs: this.selectedGlobalOption('legs'),
                    sets: this.selectedGlobalOption('sets'),
                    ranked: this.selectedGlobalOption('ranked'),
                    options: this.parseOptions(),
                    starting_options: this.parseStartingOptions(),
                }
                axios.post('/games/cpu', data)
                    .then( e => {
                        toastSuccess("Spielanfrage erstellt");
                        window.location.href = "/games/" + e.data.id;
                    })
                    .catch(e => {
                        toastError("Fehler bei Erstellung der Anfrage");
                    })
            },
            filterOption(option) {
                if (option.hidden) return false;
                if (!option.showif) return true;
                let id = option.showif.split(":")[0];
                let value = option.showif.split(":")[1];
                let returnValue = false;
                this.globalOptions.forEach(go => {
                    if (id == go.id) {
                        returnValue = value == go.selected;
                    }
                });
                return returnValue;
            }
        }
    }
</script>

<style scoped>
    #matchtype_selection {
        margin: 0 0 1em;
    }
    .matchtype_button {
        width: 8em;
        height: 2em;
        line-height: 2em;
        font-size: 2em;
        text-align: center;
        border: 1px solid #000;
        cursor: pointer;
    }
    .matchtype_button.active {
        background-color: #e0123c;
        color: #fff;
    }

    .optionSelector {
        border-top: 1px solid #aaa;
        padding: 0.5em;
        margin: 0 0 0.25em 2em;
    }

    .options_button {
        min-width: 5em;
        height: 2.5em;
        line-height: 2.5em;
        font-size: 1.2em;
        text-align: center;
        border: 1px solid #000;
        cursor: pointer;
        display: inline-block;
        margin: 0.2em;
        padding: 0 1em;
    }
    .options_button.active {
        background-color: #e0123c;
        color: #fff;
    }

    .range_button {
        font-size: 3em;
        font-weight: bold;
        text-decoration: none;
        color: #333;
        min-width: 1em;
        height: 1em;
        line-height: 1em;
        padding: 0 0.5em 0 0.5em;
        text-align: center;
    }
    .range_button:hover {
        background-color: #e0123c;
        color: #fff;
    }

    .range_button_number {
        font-size: 2.5em;
        text-decoration: none;
        color: #333;
        min-width: 1em;
        height: 1em;
        line-height: 1em;
        padding: 0.2em 0.5em 0.97em 0.5em;
        text-align: center;
        background-color: #e0123c;
        color: #fff;
    }

    h4 {
        font-size: 1.5em;
        display: inline-block;
        min-width: 8em;
    }
</style>
